import { defineStore } from "pinia";
import { ref } from "vue";

export const useKeepAliveCacheStore = defineStore("keepAliveCache", () => {
	const cacheList = ref<string[]>([]);

	const MAX_CACHE_SIZE = import.meta.env.VITE_MAX_CACHE_SIZE
		? parseInt(import.meta.env.VITE_MAX_CACHE_SIZE, 10)
		: 30;

	function addCache(name: string) {
		if (!cacheList.value.includes(name)) {
			// 如果缓存已达到最大数量，移除最早添加的项
			if (cacheList.value.length >= MAX_CACHE_SIZE) {
				cacheList.value.shift(); // 移除数组中的第一个元素（最早添加的）
			}

			cacheList.value.push(name);
		} else {
			// 如果已经存在，将其移到数组末尾，表示最近访问
			const index = cacheList.value.indexOf(name);

			cacheList.value.splice(index, 1);
			cacheList.value.push(name);
		}
	}

	function removeCache(name: string) {
		cacheList.value = cacheList.value.filter((item) => item !== name);
	}

	function clearCache() {
		cacheList.value = [];
	}

	return {
		cacheList,
		MAX_CACHE_SIZE,
		addCache,
		removeCache,
		clearCache,
	};
});
